import { Box, Dialog, Divider, Grid, IconButton, Typography } from "@mui/material";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";

const ViewEvent = ({ open, setOpen, data }) => {
  return (
    <>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <Box p={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex">
              <span
                style={{
                  background: "#884ea0",
                  marginTop: 9,
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                }}
              ></span>
              <Typography variant="subtitle2" ml={1}>
                {`${data?.calanderType} | 
                ${data?.type}`}
              </Typography>
            </Box>
            <Box display="flex">
              <>
                <IconButton onClick={() => setOpen(false)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            </Box>
          </Box>
          <Divider />
          <Grid container spacing={2} mt={1}>
            {data.client && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Client Name:
                </Typography>
                <Typography variant="body1">
                  {data?.client ? data.client?.displayName : "Na"}
                </Typography>
              </Grid>
            )}
            {data.clientGroup && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Client Group Name:
                </Typography>
                <Typography variant="body1">
                  {data?.clientGroup ? data.clientGroup?.displayName : "Na"}
                </Typography>
              </Grid>
            )}
            {data?.calanderType === "Traces Notice" ? (
              <>
                <Grid item xs={6}>
                  <Typography variant="caption" fontWeight="bold">
                    Event Title:
                  </Typography>
                  <Typography variant="body1">{data?.commCat ? data?.commCat : "Na"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight="bold">
                    Date:
                  </Typography>
                  <Typography variant="body1">
                    {" "}
                    {moment(data.date).format("MMMM DD, YYYY")}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight="bold">
                    Reference No:
                  </Typography>
                  <Typography variant="body1">{data?.commRefNo ? data.commRefNo : "Na"}</Typography>
                 
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" fontWeight="bold">
                    Description:
                  </Typography>

                  <Box
                    sx={{ "& h3, & p, & ol, & ul": { margin: 0 } }}
                    dangerouslySetInnerHTML={{
                      __html: data?.description ? data.description : "NA",
                    }}
                  ></Box>
                </Grid>
              </>
            ) : (
              <>
               <Grid item xs={6}>
                  <Typography variant="caption" fontWeight="bold">
                    AY:
                  </Typography>
                  <Typography variant="body1">{data?.ay ? data?.ay : "--"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" fontWeight="bold">
                    Notice Section:
                  </Typography>
                  <Typography variant="body1">
                    {data?.noticeSection ? data.noticeSection : "Na"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                   <Typography variant="caption" fontWeight="bold">
                    Event Title:
                  </Typography>
                  <Typography variant="body1">
                    {data?.proceedingName ? data?.proceedingName : "Na"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight="bold">
                    Date:
                  </Typography>
                  <Typography variant="body1">
                    {data.date
                      ? moment(data.date, "DD-MM-YYYY").format("MMMM DD, YYYY")
                      : "--"}
                  </Typography>
                </Grid>
               

                <Grid item xs={12}>
                  <Typography variant="caption" fontWeight="bold">
                    Notice DIN:
                  </Typography>

                  <Box
                    sx={{ "& h3, & p, & ol, & ul": { margin: 0 } }}
                    dangerouslySetInnerHTML={{
                      __html: data?.noticeDin ? data.noticeDin : "NA",
                    }}
                  ></Box>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};

export default ViewEvent;
